import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { SourceForm } from '../components/SourceForm'
import { getSources } from '../lib/api'
import type { Source } from '../lib/api'

export const Sources = () => {
  const [sources, setSources] = useState<Source[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)

  const load = () => {
    getSources()
      .then((res) => setSources(res.data))
      .catch(() => {})
      .finally(() => setIsLoading(false))
  }

  useEffect(() => { load() }, [])

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem' }}>
        <h2>Quellen</h2>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>
          + Neue Quelle
        </button>
      </div>

      {isLoading ? (
        <p>Laden...</p>
      ) : sources.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '2rem' }}>
          {sources.map((s) => (
            <Link key={s.id} to={`/sources/${s.id}`} style={{ textDecoration: 'none' }}>
              <div className="card" style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '0.875rem 1.125rem', marginBottom: 0 }}>
                <div style={{
                  width: 36, height: 36, borderRadius: 'var(--radius-sm)',
                  background: s.type === 'book' ? 'var(--primary)' : '#6b7280',
                  color: 'white', display: 'flex', alignItems: 'center',
                  justifyContent: 'center', fontSize: '1.1rem', flexShrink: 0,
                }}>
                  {s.type === 'book' ? '📖' : '📄'}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 600, color: 'var(--text-primary)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {s.title}
                  </div>
                  {(s.authors?.length > 0 || s.year) && (
                    <div style={{ fontSize: '0.8125rem', color: 'var(--text-secondary)', marginTop: '0.2rem' }}>
                      {s.authors?.length > 0 && s.authors.map((a) => a.name).join(', ')}
                      {s.authors?.length > 0 && s.year && ' · '}
                      {s.year}
                    </div>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <p>Noch keine Quellen vorhanden.</p>
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <SourceForm
              onSuccess={() => { load(); setShowModal(false) }}
              onCancel={() => setShowModal(false)}
            />
          </div>
        </div>
      )}
    </div>
  )
}
